import { useEffect } from 'react';
import { useStore } from '../store/StoreContext.jsx';

// A brief "row removed · Undo" toast for the R4 undo window. Restores the
// deleted row on click or Ctrl/Cmd+Z. The keyboard shortcut is only active
// while a deletion is pending, and it deliberately yields to native
// input/textarea undo so it never hijacks in-field editing.
export default function UndoToast() {
  const { pendingUndo, undoDelete } = useStore();

  useEffect(() => {
    if (!pendingUndo) return undefined;
    const onKey = e => {
      const isUndo = (e.ctrlKey || e.metaKey) && !e.shiftKey && (e.key === 'z' || e.key === 'Z');
      if (!isUndo) return;
      const el = document.activeElement;
      const editing = el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);
      if (editing) return; // let the field's own undo run
      e.preventDefault();
      undoDelete();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [pendingUndo, undoDelete]);

  if (!pendingUndo) return null;
  const label = pendingUndo.label ? `${pendingUndo.label} removed` : 'Row removed';
  return (
    <div className="undo-toast" role="status">
      <span className="undo-toast-msg">{label}</span>
      <button type="button" className="undo-toast-btn" onClick={undoDelete}>Undo</button>
    </div>
  );
}
